import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CookiePrivacyBanner } from './components/CookiePrivacyBanner';
import { MasterFooter } from './components/MasterFooter';
import { NearbyDealsWidget } from './components/NearbyDealsWidget';
import { SiteHeader } from './components/SiteHeader';
import { HomePage } from './pages/HomePage';
import { MerchantDashboard } from './pages/MerchantDashboard';
import { ProfilePage } from './pages/ProfilePage';
import { ResultsPage } from './pages/ResultsPage';
type AppView = 'home' | 'results' | 'profile' | 'merchant';
export function App() {
  const [view, setView] = useState<AppView>('home');
  const [search, setSearch] = useState('Chicago, IL');
  const [selectedPharmacy, setSelectedPharmacy] = useState('northridge');
  const reduceMotion = useReducedMotion();
  const goToResults = (query: string) => {
    setSearch(query);
    setView('results');
  };
  const openProfile = (id: string) => {
    setSelectedPharmacy(id);
    setView('profile');
  };
  return <div className="min-h-screen bg-[#F7F7F7] text-[#1C1C1C]" data-id="element-0" data-mp="3ijpc2xoqyt86">
      <SiteHeader view={view} onNavigate={setView} data-id="element-1" data-mp="3mkrgdsxitvh0" />
      <AnimatePresence mode="wait" initial={false} data-id="element-2" data-mp="3mj6hjr46bqdc">
        <motion.div key={view} initial={reduceMotion ? false : {
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={reduceMotion ? undefined : {
        opacity: 0,
        y: -5
      }} transition={{
        duration: 0.18,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-3" data-mp="3rdar8i4tqci4">
          {view === 'home' && <HomePage onSearch={goToResults} onOpenMerchant={() => setView('merchant')} data-id="element-4" data-mp="nur6s1se0axv" />}
          {view === 'results' && <ResultsPage search={search} onSearch={goToResults} onSelect={openProfile} data-id="element-5" data-mp="35oz0whm5evr" />}
          {view === 'profile' && <ProfilePage pharmacyId={selectedPharmacy} onBack={() => setView('results')} onClaim={() => setView('merchant')} data-id="element-6" data-mp="d57h17dyqql6" />}
          {view === 'merchant' && <MerchantDashboard onExit={() => openProfile('northridge')} data-id="element-7" data-mp="3gm665vw9h56i" />}
        </motion.div>
      </AnimatePresence>
      <MasterFooter data-id="element-8" data-mp="3bk70uggyny6x" />
      <NearbyDealsWidget data-id="element-9" data-mp="3qb7jtffc3ahb" />
      <CookiePrivacyBanner data-id="element-10" data-mp="3qbfv52vt67qe" />
    </div>;
}